<template>
  <a-drawer
    :title="id === 0 ? 'Añadir nuevo parte' : 'Editar parte #' + id"
    :width="420"
    :visible="visible"
    :body-style="{ paddingBottom: '84px' }"
    @close="$emit('close')"
  >
    <validation-observer v-slot="{ passes, invalid }">
      <form @submit.prevent="passes(save)">
        <div class="row">
          <div class="col-6">
            <g-field
              v-model="fields.ParteFecha"
              :app="app"
              :item="id"
              name="ParteFecha"
              title="Fecha"
            />
          </div>
          <div class="col-6">
            <g-field
              v-model="fields.ParteHoras"
              :app="app"
              :item="id"
              name="ParteHoras"
              title="Horas"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <g-field
              v-model="fields.ParteHoraEntrada"
              :app="app"
              :item="id"
              name="ParteHoraEntrada"
              title="Hora de entrada"
            />
          </div>
          <div class="col-6">
            <g-field
              v-model="fields.ParteHoraSalida"
              :app="app"
              :item="id"
              name="ParteHoraSalida"
              title="Hora de salida"
            />
          </div>
        </div>

        <div class="row">
          <div class="col">
            <g-field
              v-model="fields.ParteReferencia"
              :app="app"
              :item="id"
              name="ParteReferencia"
              title="Referencia"
            />
          </div>
        </div>

        <div class="row">
          <div class="col">
            <g-field
              v-model="fields.ParteTurno"
              :app="app"
              :item="id"
              name="ParteTurno"
              title="Turno"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <g-field
              v-model="fields.PartePiezasOk"
              :app="app"
              :item="id"
              name="PartePiezasOk"
              title="Piezas OK"
            />
          </div>
          <div class="col-6">
            <g-field
              v-model="fields.PartePiezasKo"
              :app="app"
              :item="id"
              name="PartePiezasKo"
              title="Piezas KO"
            />
          </div>
        </div>

        <div class="row">
          <div class="col">
            <g-field
              v-model="fields.ParteObservaciones"
              :app="app"
              :item="id"
              name="ParteObservaciones"
              type="textarea"
              title="Observaciones"
            />
          </div>
        </div>

        <div
          class="d-flex"
          :style="{
            position: 'absolute',
            left: 0,
            bottom: 0,
            width: '100%',
            padding: '10px 16px',
          }"
        >
          <a-button
            type="danger"
            :style="{ marginRight: '8px' }"
            @click="resetForm"
          >
            Resetear
          </a-button>

          <a-button
            class="ml-auto"
            :style="{ marginRight: '8px' }"
            @click="$emit('close')"
          >
            Cancelar
          </a-button>

          <a-button
            type="primary"
            html-type="submit"
            :loading="loading"
            :disabled="invalid"
          >
            {{ id === 0 ? 'Añadir' : 'Modificar' }}
          </a-button>
        </div>
      </form>
    </validation-observer>
  </a-drawer>
</template>

<script>
export default {
	name: 'MarasPartesForm',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		id: {
			type: Number,
			default: null
		}
	},
	data() {
		return {
			view: 'partesList',
			app: 'partes',
			loading: false,
			fields: {
				ParteFecha: this.$moment(),
				ParteHoras: 0,
				ParteTurno: 0,
				PartePiezasOk: 0,
				PartePiezasKo: 0,
				ParteHoraEntrada: null,
				ParteHoraSalida: null,
				ParteReferencia: '',
				ParteObservaciones: ''
			}
		};
	},
	methods: {
		async save() {
			this.loading = true;

			const params = this.fields;

			let data;
			if (this.id > 0) {
				data = await this.$gestios.items('partes').edit({ id: this.id, params });
			} else {
				data = await this.$gestios.items('partes').add({ params, view: this.view });
			}

			if (data.ok) this.$emit('close');

			this.loading = false;
		},
		resetForm() {
			this.fields = {
				ParteFecha: this.$moment(),
				ParteHoras: 0,
				ParteTurno: 0,
				PartePiezasOk: 0,
				PartePiezasKo: 0,
				ParteHoraEntrada: null,
				ParteHoraSalida: null,
				ParteReferencia: '',
				ParteObservaciones: ''
			};
		}
	}
};
</script>

<style></style>
